/**
 * Amazon Affiliate Recommendation Card
 * Reusable component for all blog posts
 */

const products = [
  {
    href: 'https://amzn.to/3MishD3',
    titleEn: 'Wealth Your Way',
    titleZh: '財富之路',
    subtitleEn: 'A Financial Freedom Roadmap',
    subtitleZh: '財務自由路線圖',
  },
  {
    href: 'https://amzn.to/4thod6Z',
    titleEn: 'Budget Planner',
    titleZh: '預算規劃本',
    subtitleEn: 'Organizer & Finance Tracker',
    subtitleZh: '理財記帳本',
  },
  {
    href: 'https://amzn.to/3LUH9aP',
    titleEn: 'Full Focus Planner',
    titleZh: '全面聚焦規劃本',
    subtitleEn: 'by Michael Hyatt',
    subtitleZh: 'Michael Hyatt 著',
  },
  {
    href: 'https://amzn.to/4tqMdVe',
    titleEn: 'Smart Calendar',
    titleZh: '智能日曆',
    subtitleEn: 'Interactive Touchscreen Planner',
    subtitleZh: '互動觸控屏規劃器',
  },
  {
    href: 'https://amzn.to/3Zmp2xp',
    titleEn: 'The Simple Path to Wealth',
    titleZh: '簡單致富之道',
    subtitleEn: 'Revised & Expanded Edition',
    subtitleZh: '修訂擴充版',
  },
];

export default function AmazonRecommendation({ isEnglish }: { isEnglish: boolean }) {
  return (
    <div
      style={{
        background: '#fffbeb',
        border: '1px solid #fcd34d',
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '30px',
      }}
    >
      {/* Header */}
      <p style={{ fontSize: '15px', fontWeight: '700', color: '#92400e', margin: '0 0 4px 0' }}>
        📚 {isEnglish ? 'Recommended for You' : '為你推薦'}
      </p>
      <p style={{ fontSize: '13px', color: '#78350f', margin: '0 0 16px 0', lineHeight: '1.5' }}>
        {isEnglish
          ? 'Grow your financial knowledge with these top-rated picks on Amazon.'
          : '透過 Amazon 精選好物，提升你嘅理財知識。'}
      </p>

      {/* Product Grid */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
          gap: '14px',
        }}
      >
        {products.map((p) => (
          <a
            key={p.href}
            href={p.href}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              background: '#fff',
              borderRadius: '10px',
              padding: '14px 10px',
              textDecoration: 'none',
              border: '1px solid #fde68a',
              transition: 'box-shadow 0.2s, transform 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(245,158,11,0.18)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.transform = 'none';
            }}
          >
            {/* Title */}
            <span
              style={{
                fontSize: '13px',
                fontWeight: '600',
                color: '#78350f',
                textAlign: 'center',
                lineHeight: '1.3',
                marginBottom: '4px',
              }}
            >
              {isEnglish ? p.titleEn : p.titleZh}
            </span>
            {/* Subtitle */}
            <span
              style={{
                fontSize: '11px',
                color: '#a16207',
                textAlign: 'center',
                lineHeight: '1.3',
                marginBottom: '10px',
              }}
            >
              {isEnglish ? p.subtitleEn : p.subtitleZh}
            </span>
            {/* CTA */}
            <span
              style={{
                fontSize: '11px',
                fontWeight: '600',
                color: '#fff',
                background: '#f59e0b',
                padding: '5px 14px',
                borderRadius: '5px',
                marginTop: 'auto',
              }}
            >
              {isEnglish ? 'View on Amazon' : '到 Amazon 查看'}
            </span>
          </a>
        ))}
      </div>

      {/* Disclosure */}
      <p style={{ fontSize: '11px', color: '#a16207', marginTop: '14px', marginBottom: 0 }}>
        {isEnglish
          ? 'As an Amazon Associate, PayWise365 earns from qualifying purchases.'
          : '作為 Amazon Associate，PayWise365 從合資格購買中賺取佣金。'}
      </p>
    </div>
  );
}
